jQuery(document).ready(function ($) {
  // obecne
  var bodyWidth = window.innerWidth;

  // události při resize okna
  $(window).on('resize', function () {
    // osetreni, zda se velikost zmenila
    if (bodyWidth !== window.innerWidth) {
      // nastavíme novou šířku
      bodyWidth = window.innerWidth;
      // zresetuj menu
      resetMenu();
    }
  });

  // události při načtení stránky
  $(window).on('load', function () {});

  // události při scroolování
  $(window).on('scroll', function () {
    // rolovací menu
    rollMenu();
  });

  // mobilní menu
  function switchMenu() {
    // označíme zda je menu zavřeno či nikoliv
    if ($('.header__hamburger').hasClass('is-active')) {
      $('.header__hamburger').removeClass('is-active');
    } else {
      $('.header__hamburger').addClass('is-active');
    }

    // otevřeme produktové menu
    if ($('.header').hasClass('is-active')) {
      $('.header').removeClass('is-active');
    } else {
      $('.header').addClass('is-active');
    }

    // aktivujeme hamburger
    if ($('.hamburger').hasClass('is-active')) {
      $('.hamburger').removeClass('is-active');
    } else {
      $('.hamburger').addClass('is-active');
    }
  }
  // při změně rozlišení resetujeme menu
  function resetMenu() {
    $('.header').removeClass('is-active');
    $('.hamburger').removeClass('is-active');
  }
  // spouštěč
  $('.header__hamburger').on('click', function () {
    switchMenu();
  });

  // rolovací menu
  function rollMenu() {
    if ($(this).scrollTop() > 1) {
      $('.header').addClass('header--fixed');
    } else {
      $('.header').removeClass('header--fixed');
    }
  }

  jQuery('.slider-slick-wrap').slick({
    lazyLoad: 'ondemand',
    dots: true,
    autoplay: 2000,
    autoplay: true,
    arrows: false,
    infinite: true,
    speed: 500,
    fade: true,
    cssEase: 'linear',
  });

  $('.menu--search').on('click', function () {
    $('.search').fadeToggle(300, function () {
      $(this).find(':input:visible').first().focus();
    });

    console.log($('#s'));
    return false;
  });

  $('.search__close').on('click', function () {
    $('.search').find(':input:visible').first().val('');
    $('.search').find(':input:visible').first().focus();
    //$('#s')[0].focus();
    return false;
  });

  $('.menu--reveal a').on('click', function () {
    var thisHref = $(this).attr('href');
    $('.tags').hide();
    $(thisHref).fadeToggle(300);
    return false;
  });

  // -------------------------------------
  // ScrollTo (click on link)
  // -------------------------------------

  var currentLocation = window.location;

  $('.js-scroll a').click(function () {
    var thisHref = $(this).attr('href');

    $.scrollTo(thisHref, 800, {
      axis: 'y',
    });

    return false;
  });

  $('.js-click').click(function () {
    $this = $(this);
    $link = $this.find('.js-click-link');
    anchor_link = $link.attr('href');

    window.open(anchor_link, '_blank');
    return false;
  });

  var ppp = 9;
  var pageNumber = 1;

  function load_posts() {
    var cat = $('#more_posts').data('id');

    pageNumber++;
    var str =
      '&cat=' +
      cat +
      '&pageNumber=' +
      pageNumber +
      '&ppp=' +
      ppp +
      '&action=more_post_ajax';
    $.ajax({
      type: 'POST',
      dataType: 'html',
      url: ajax_posts.ajaxurl,
      data: str,
      success: function (data) {
        //console.log(data);
        var $data = $(data);
        if ($data.length) {
          $('#ajax-posts').append($data);
          $('#more_posts').hide();
        } else {
          $('#more_posts').show();
        }
      },
      error: function (jqXHR, textStatus, errorThrown) {
        $loader.html(jqXHR + ' :: ' + textStatus + ' :: ' + errorThrown);
      },
    });
    return false;
  }

  $('#more_posts').on('click', function () {
    // When btn is pressed.
    $('#more_posts').attr('disabled', true); // Disable the button, temp.
    load_posts();
    return false;
  });

  $(
    ".content a[href$='.jpg'], .content a[href$='.jpeg'], .content a[href$='.png']"
  ).magnificPopup({
    type: 'image',
    tLoading: 'Náhrávám fotku...',
    mainClass: 'mfp-img-mobile',
    gallery: {
      enabled: true,
      navigateByImgClick: true,
      preload: [0, 1], // Will preload 0 - before current, and 1 after the current image
    },
  });

  $('.js-gallery').each(function () {
    // the containers for all your galleries
    $(this).magnificPopup({
      delegate: 'a',
      type: 'image',
      tLoading: 'Nahrávám fotku...',
      mainClass: 'mfp-img-mobile',
      gallery: {
        enabled: true,
        navigateByImgClick: true,
        preload: [0, 1], // Will preload 0 - before current, and 1 after the current image
      },
    });
  });

  $(".js-mobile-menu-sub").on("click", function(e){
    var $this = $(this);
    var $thisSubmenu = $this.find("ul");
    $this.toggleClass("is-open");
    $thisSubmenu.toggle();
    e.stopPropagation();
  });
});
